import type { Nullable } from '@iheartjane/types';

export const ensureNumericId = (id?: Nullable<string | number>) => {
  const numericId = Number(id);

  if (!numericId || Number.isNaN(numericId)) {
    throw new Error(`[ensureNumericId]: Invalid ID ${id}`);
  }

  return numericId;
};
